export enum TwitterCardType {
	SUMMARY = 'summary',
	SUMMARY_LARGE = 'summary_large_image',
	APP = 'app'
}
